module.exports = new __parcel__URL__("kaiju_kingmaker_level_3.0c708920.png").toString();